module cr.events {
    class TrackingService implements ITrackingService {
        bibDetails: {};
        bibNumber:Number;
        //endpoint:string = "https://prod.chronorace.be/api/";
        endpoint:string = "http://localhost:16151/api/";


        static $inject = ['$http','cfg'];

        constructor(private $http,cfg) {
            if (angular.isDefined(cfg.EventApiUrl))
            {
                this.endpoint=cfg.EventApiUrl;
            }

            console.log("endpoint: "+this.endpoint);
        }

        getTrack(eventId:string,trackName:string)
        {
            return this.$http.jsonp(this.endpoint+'gps/track/'+ eventId+'/'+trackName+'?callback=JSON_CALLBACK')
                .then((result) => {
                    return result.data;
                });
        }

        getPosition(trackersOrEvent)
        {
            return this.$http.jsonp(this.endpoint+'gps/get/'+ trackersOrEvent+'?callback=JSON_CALLBACK')
                .then((result) => {
                    return result.data;
                });
        }

        getLog(eventId:string,tk:string)
        {
            return this.$http.jsonp(this.endpoint+'gps/log/'+ eventId+'/'+tk+'?callback=JSON_CALLBACK')
                .then((result) => {
                    return result.data;
                });
        }

        gpsConfiguration(eventId:string)
        {
            console.log(this.endpoint+'gps/config/'+ eventId+'?callback=JSON_CALLBACK');
            return this.$http.jsonp(this.endpoint+'gps/config/'+ eventId+'?callback=JSON_CALLBACK')
                .then((result) => {
                    return result.data;
                });
        }

        getLineChartInfo(eventId:string, groupId:Number, partition:Number,location:string): angular.IPromise<any> {
            console.log("getLineChart: "+location);
            return this.$http.jsonp(this.endpoint+'results/live/ligne/split_stat/'+ groupId + '/'+location +'/'+eventId+'?partition='+partition+'&callback=JSON_CALLBACK')
                .then((result) => {
                   return result.data;
                });
        }

        getEventConfiguration(eventId:string): angular.IPromise<any>{

            return this.$http.jsonp(this.endpoint+'Event/cfg/'+ eventId+ '?callback=JSON_CALLBACK')
                .then((result) => {
                    return result.data;
                });
        }

        getOverview(eventId:string,groupId:number=-1): angular.IPromise<any>{
            return this.$http.jsonp(this.endpoint+'results/live/ligne/overview/'+ eventId+ '?groupId='+groupId+'&callback=JSON_CALLBACK')
                .then((result) => {
                    return result.data;
                });
        }


        getEventView(eventId:string): angular.IPromise<any>{

            return this.$http.jsonp(this.endpoint+'Event/view/'+ eventId+ '?callback=JSON_CALLBACK')
                .then((result) => {
                    return result.data;
                });
        }

        //[Route("get/{groupId}/{resultName}/{eventId}/{timingSoftwareContext?}/{filter?}/{partitionName?}/{partitionValue?}/{from?}/{max?}")]
        getResult(groupId:string,resultName:string, eventId:string,filter:number=0,from:number=0,max:number=25): angular.IPromise<any>{
            return this.$http.jsonp(this.endpoint+'results/live/ligne/get/'+groupId+'/'+resultName+'/' + eventId+ '?from='+from+'&max='+max+'&callback=JSON_CALLBACK')
                .then((result) => {
                    return result.data;
                });
        }

        overview(eventId:string, groupId:number, mask:number=0, search:string=null,from:number=0,max:number=25): angular.IPromise<any>{
            console.log("ovrview - from: "+from+"/"+max);
            return this.$http.jsonp(this.endpoint+'results/live/ligne/overview/'+eventId+'?group='+ groupId+'&andmask='+mask+'&from='+from+'&max='+max+'&callback=JSON_CALLBACK')
                .then((result) => {
                    return result.data;
                });
        }

        searchRegistration(eventId:string,search:string): angular.IPromise<any>{

            return this.$http.jsonp(this.endpoint+'Registration/search/'+ eventId+ '?search='+encodeURI(search)+'&callback=JSON_CALLBACK')
                .then((result) => {
                    return result.data;
                });

        }

        getBarChartInfo(eventId:string, groupId:Number): angular.IPromise<any> {
            return this.$http.jsonp(this.endpoint + 'results/live/ligne/group_stat/'+groupId+ '/' + eventId + '?callback=JSON_CALLBACK')
                .then((result) => {
                    return result.data;
                });
        }

        getTimingConfiguration(eventId:string): angular.IPromise<any>{
            console.log("GetTimingCofiguration");

            return this.$http.jsonp(this.endpoint + "results/live/ligne/cfg/" + eventId + '?callback=JSON_CALLBACK')
                .then((result) => {
                    return result.data;
                });
        }

        getBibDetails(eventId:string, bibId:Number): angular.IPromise<any>{
            return this.$http.jsonp(this.endpoint + "results/live/ligne/detail/" + bibId + '/' + eventId + '?callback=JSON_CALLBACK')
                .then((result) => {
                    this.bibDetails = result.data;
                    this.bibNumber = bibId;

                    return result.data
                });
        }
    }

    eventModule.service('TrackingService', TrackingService);
}
